/**
 * @file   src\components\Onboarding\CommonHeader.js
 * @brief  This file is responsible for header section in web view
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Tooltip from "react-bootstrap/Tooltip";
import GitchaLogo from "../../images/gitcha-logo.svg";
import MemberUserProfileModal from "./UserRegister/MemberUserProfileModal";
import ResetPassword from "./UserRegister/ResetPassword";
import {
  clearLocalStorage,
  getLocalStorage,
  loggedInUser,
  setLocalStorage,
  clearLocalStorageOnLogout,
  getUserId,
  removeLocalStorage,
  checkTutorialDisplayStatus,
  getCurrentPath,
  getUserType,
} from "../../helpers/common";
import {
  saveAgentInfo,
  saveUserType_Title,
} from "../../services/v2/signupService";
import {
  saveGoogleLoginUser,
  getGoogleUserInfo,
} from "../../services/loginService";
import { useSearchParams } from "react-router-dom";

import _, { get } from "lodash";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { pageURLs } from "../../constants/pageURLs";
import Dropdown from "react-bootstrap/Dropdown";
import {
  USER_INFO_KEY,
  USER_TYPE_AGENT,
  USER_TYPE_MEMBER,
  WANT_AD,
  WANT_AD_ARRAY_KEY,
  INAPPNOTIFICATIONCOUNT,
  NOTIFICATIONCOUNT,
  INVENTORY_KEY,
  NOT_FREE_OR_MEMBER_PERIOD,
  INVESTOR_MEMBER_PLAN,
} from "../../constants/common";
import AgentTitleModal from "./UserRegister/AgentTitleModal";
import CheckAgentModal from "./UserRegister/CheckAgentModal";
import AgentInfoModal from "./UserRegister/v2/AgentInfoModal";
import AgentLiketoStartModal from "./UserRegister/AgentLiketoStartModal";
import {
  getInAppNotications,
  getIntroductions,
  updateInAppDeleteStatus,
  updateInAppReadStatus,
  updateIntroShowStatus,
} from "../../services/introductionService";
import { toast } from "react-toastify";
import EmailVerifiedModal from "./UserRegister/EmailVerifiedModal";
import EmailChangeConfirmedModal from "./UserRegister/EmailChangeConfirmedModal";
import EmailChangeRevokedModal from "./UserRegister/EmailChangeRevokedModal";
import CheckEmailDeletionModal from "./UserRegister/CheckEmailDeletionModal";
import Introductions from "../HeaderButtons/v2/Introductions";
import Notifications from "../HeaderButtons/v2/Notifications";
import {
  fetchUserDetails,
  fetchUserPrivileges,
} from "../../actions/userprofile";
import BasicPlanModal from "../PlanUpgrade/BasicPlanModal";
import PremiumPlanModal from "../PlanUpgrade/PremiumPlanModal";
import { signOutFirebase } from "../../helpers/message";
import AgentOnboardingModal from "./UserRegister/AgentOnboardingModal";
import {
  EMAIL_VERIFICATION,
  HOME,
  POST_WANT_AD,
  RESET_PWD_ACTION,
  resetModalemailOnly,
  resetModalpwdOnly,
} from "../../constants/onBoarding";
import { LOGIN, SIGNUP } from "../../constants/onBoarding";
import CheckResetEmailModal from "./UserRegister/CheckResetEmailModal";
import { convertToNumber } from "../../helpers/validations";
import base64 from "base-64";
import utf8 from "utf8";
import DeleteNotificationModalNew from "./DeleteNotificationModalNew";
import { changeUserName } from "../../services/v2/userprofileService";
import ContactModal from "./ContactModal";
import { getWantAdById, unArchiveWantAd } from "../../services/wantAdService";
import WantAdRenewConfirmationModal from "./WantAdRenewConfirmationModal";
import ProfileImageCropper from "../../mobile/components/Onboarding/ProfileImageCropper";
import { userEmailVerification } from "../../services/v2/signupService";
import {
  resetPassword,
  updatePassword,
  verifyUserAction,
} from "../../services/v2/loginService";
import { setInappNotificationCount } from "../../reducers/unReadStatus";
import { triggerOnboarding } from "../../services/userpilot";

const CommonHeader = (props) => {
  const {
    handleCanvasShow,
    wantAdClickCounter,
    updateInventoryState,
    redirectToHomePage,
    isMatch,
    openSignIn,
    refresh,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const tutorialPage = 4; //Agent Dashboard
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );
  const [userDetails, setUserDetails] = useState(null);
  const state = location.state;
  const user = loggedInUser(); //userState();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const userId = searchParams.get("Id");
  const gCode = searchParams.get("g_code");
  const action = searchParams.get("action");
  const isFromSettings = searchParams.get("isFromSettings");

  const [email, setEmail] = useState("");

  const [userPreference, setUserPreference] = useState("");
  const [agentTitleModalShow, setAgentTitleModal] = useState(false);
  const [userTypeModalShow, setUserTypeModal] = useState(false);
  const [agentPreferenceModal, setAgentPreferenceModal] = useState(false);
  const [agentProfileModal, setAgentProfileModal] = useState(false);
  const [memberProfileModal, setMemberProfileModal] = useState(false);
  const [selectedTitle, setTitle] = useState();
  const [userType, setUserType] = useState();
  const [titleContinueState, setTitleButtonState] = useState();
  const [isDisabledUserContinue, setUserTypeContinueButton] = useState(true);
  const [agentPreference, setAgentPreference] = useState();
  const [showEmailVerifiedModal, setShowEmailVerifiedmodal] = useState(false);
  const [showEmailConfirmedModal, setShowEmailConfirmedModal] = useState(false);
  const [showEmailChangeRevokedModal, setShowEmailChangeRevokedModal] =
    useState(false);
  const [isLoadIntroList, setLoadIntroList] = useState(false);
  const [introductionList, setIntroductionList] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [showIntroList, setIntroList] = useState(true);
  const INTRO_LIST_PAGE_LIMIT = 4;
  const [checkEmailPopup, setCheckEmailPopup] = useState(false);
  const [emailNotVerified, setEmailNotVerified] = useState(false);
  const actionArray = ["5", "6", "7", "8", "9"];
  const UserId =
    _.get(user, "userInfo.userId", null) ||
    _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);
  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);
  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const BasicPlanModalClose = () => setBasicPlanModal(false);
  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const [reload, setReload] = useState(0);
  const [agentOnboardingPopup, setAgentOnboardingPopup] = useState({});
  // un read messages status for handshake icon
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [resetPwdModal, setResetPwdModal] = useState(false);
  const [resetPwdModalType, setResetModalType] = useState(resetModalemailOnly);
  const [resetEmailModalState, setResetEmailState] = useState(false);

  // in- app notification
  const [isLoadNotificationList, setLoadNotificationList] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [deleteNotificationModal, setDeleteNotificationModal] = useState(false);
  const handleDeleteNotificationPopupClose = () =>
    setDeleteNotificationModal(false);

  // wantad renew confirmation
  const [wantAdRenewModal, setWantAdRenewModal] = useState(false);
  const handleWantAdRenewPopupClose = () => setWantAdRenewModal(false);
  const [wantAdForRenew, setWantAdForReniew] = useState(null);

  // un read messages status for handshake icon
  const [unreadNotificationMessageCount, setUnreadNotificationMessageCount] =
    useState(0);

  let { unreadInappNotificationCount } = useSelector(
    (state) => state.unreadCount,
  );
  unreadInappNotificationCount = unreadInappNotificationCount?.payload;

  // sse data
  let { sseData } = useSelector((state) => state.sseData);
  const sseTriggedData = sseData?.payload;

  let showAgentIcon = checkTutorialDisplayStatus(tutorialPage);
  const [isPremiumUser, setIsPremiumUser] = useState(null);
  const [userPlan, setUserPlan] = useState("");

  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(state && state.deleteAccount === true ? true : false);

  // contact modal
  const [contactModalState, setContactModalState] = useState(false);
  const ContactModalClose = () => setContactModalState(false);
  const ContactModalShow = () => setContactModalState(true);

  const [showAgentMenuNotificationIcon, setAgentMenuNotificationIcon] =
    useState(false);
  let DisplayWantAddOnboard = checkTutorialDisplayStatus(6); //Want add onboard display
  let DisplayInventoryAddOnboard = checkTutorialDisplayStatus(7); //Inventory onboard display

  let currentURL = getCurrentPath(); // to get current path

  const [image, setImage] = useState(null);
  const [showPofileImageUploadModal, setShowPofileImageUploadModal] =
    useState(false);
  const [isSquareImage, setIsSquareImage] = useState(false);
  const ShowPofileImageUploadModalClose = () =>
    setShowPofileImageUploadModal(false);
  const ShowPofileImageUploadModalShow = (isSquare) => {
    setIsSquareImage(isSquare);
    setShowPofileImageUploadModal(true);
  };

  const [reRenderEditProfileModel, setReRenderEditProfileModel] = useState(0);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [uploadedLogoUrl, setUploadedLogoUrl] = useState("");

  const renderEditProfileModel = (uploadedImageUrl) => {
    isSquareImage
      ? setUploadedLogoUrl(uploadedImageUrl)
      : setUploadedImageUrl(uploadedImageUrl);
    setReRenderEditProfileModel(reRenderEditProfileModel + 1);
  };
  /**
   * To handle google login
   */
  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      if (_.get(tokenResponse, "access_token", null)) {
        const token = {
          accessToken: tokenResponse.access_token,
          googleLogin: true,
        };
        setLocalStorage(USER_INFO_KEY, { token: token });
        handleGoogleLogin();
      }
    },
  });

  useEffect(() => {
    if (openSignIn && refresh && !userId) {
      handleAgentOnboardingModal({ showPopup: true, userAction: SIGNUP });
    }
  }, [refresh]);

  const userData = getLocalStorage(USER_INFO_KEY);
  const [sessionData, setSessionData] = useState(
    getLocalStorage(USER_INFO_KEY),
  );

  useEffect(() => {
    if (sseTriggedData?.messageType == "in-app") {
      getNotificationList();
      if (sseTriggedData?.subjectType === 12) {
        const pathName = _.get(location, "pathname", null);
        if (pathName && pathName === pageURLs.memberInventoryDetails) {
          const inventoryId = _.get(
            getLocalStorage(INVENTORY_KEY),
            "inventoryId",
            null,
          );
          if (inventoryId) {
            updateInventoryState(inventoryId);
          }
        }
        if (pathName && pathName === pageURLs.mobilememberInventoryDetails) {
          const inventoryId = _.get(
            getLocalStorage(INVENTORY_KEY),
            "inventoryId",
            null,
          );
          if (inventoryId) {
            updateInventoryState(inventoryId);
          }
        }
      }
    } else if (sseTriggedData?.messageType == "receiveIntroduction") {
      const wantAdId = null;
      getIntroductionList(currPage, wantAdId);
    }
  }, [sseTriggedData]);

  useEffect(() => {
    setSessionData(userData);
  }, [userData?.userInfo?.ClientCount]);

  useEffect(() => {
    if (userType) {
      setUserTypeContinueButton(false);
    } else {
      setUserTypeContinueButton(true);
    }
  }, [userType]);

  const renderTooltip = (params) => (
    <Tooltip id="button-tooltip" {...params}>
      Simple tooltip
    </Tooltip>
  );
  /**
   * To save details of user signed up using google sign up
   * @param {*} param0
   */
  const saveGoogleUserDetails = async ({
    FirstName,
    LastName,
    Email,
    IsGoogleVerified,
  }) => {
    const reqPayLoad = {
      FirstName: FirstName,
      LastName: LastName,
      Email: Email,
      IsVerified: true,
      IsGoogleVerified: IsGoogleVerified,
      UserPreference: userPreference,
    };

    await saveGoogleLoginUser(reqPayLoad).then((response) => {
      if (response) {
        const result = _.get(response, "result", null);
        const userType = convertToNumber(_.get(result, "UserTypeId", ""));
        const IsVerified = _.get(result, "IsVerified", "") === 1;
        if (response.errorCode === 0 && IsVerified) {
          const IsLogin = _.get(result, "IsLogin", "");
          const firstName = _.get(result, "FirstName", "");
          const lastName = _.get(result, "LastName", "");
          const name = firstName + " " + lastName;
          const userDetails = {
            token: {
              accessToken: _.get(result, "sessionToken", ""),
              refreshToken: _.get(result, "refreshToken", ""),
              googleLogin: true,
            },
            userInfo: {
              userId: _.get(result, "UserId", ""),
              email: _.get(result, "Email", ""),
              firstName: firstName,
              lastName: lastName,
              name: name,
              userPreference: userPreference,
              userType: userType,
              userIsVerified:
                _.get(result, "IsGoogleVerified", "") === "false"
                  ? false
                  : true,
              planStatus:
                _.get(result, "planStatus", "") === "false" ? false : true,
              userStatus:
                _.get(result, "UserStatus", "") === "false" ? false : true,
              image: _.get(result, "image", ""),
            },
          };
          if (userType === USER_TYPE_AGENT) {
            const agentTitle = _.get(result, "Agent_Title", "");
            userDetails.userInfo.agentTitle = agentTitle;
          }

          setLocalStorage(USER_INFO_KEY, userDetails);

          //Saving tutorial displayed status page
          const tutorialStatus = _.get(result, "tutorialStatus", "");
          if (tutorialStatus && tutorialStatus.length) {
            let tutorialDisplayedPages = [];
            for (let i = 0; i < tutorialStatus.length; i++) {
              if (
                tutorialStatus[i].PageNo &&
                tutorialStatus[i].Status == 1 &&
                !tutorialDisplayedPages.includes(tutorialStatus[i].PageNo)
              ) {
                tutorialDisplayedPages.push(tutorialStatus[i].PageNo);
              }
            }
            setLocalStorage("tutorialDisplayedPages", tutorialDisplayedPages);
          }

          handleAgentOnboardingModal({ showPopup: false, userAction: null });

          handleUserLogin();
        }
      }
    });
  };
  /**
   * To handle google login
   */
  const handleGoogleLogin = async () => {
    await getGoogleUserInfo()
      .then((response) => {
        const reqPayload = {
          FirstName: _.get(response, "given_name", ""),
          LastName: _.get(response, "family_name", ""),
          Email: _.get(response, "email", ""),
          IsGoogleVerified: _.get(response, "email_verified", ""),
        };
        saveGoogleUserDetails(reqPayload);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  useEffect(() => {
    const userId = getUserId();

    if (userId) {
      dispatch(fetchUserDetails());
    }
  }, [reload]);

  const handleResetEmailModal = ({ modalState }) => {
    setResetEmailState(modalState);
  };

  const updateReloadParam = () => {
    setReload(reload + 1);
  };

  useEffect(() => {
    const IsFromMarketing = searchParams.get("IsFromMarketing");
    const userType = _.get(userData, "userInfo.userType", null);

    // utm data
    const utm_source = searchParams.get("utm_source");
    const utm_medium = searchParams.get("utm_medium");
    const utm_campaign = searchParams.get("utm_campaign");
    if (utm_source || utm_medium || utm_campaign) {
      setLocalStorage("utmData", {
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
      });
    }

    if (IsFromMarketing) {
      const userAction = searchParams.get("userAction");
      const userActionLogin = "LOGIN";
      const userActionSignUp = "SIGNUP";
      const userActionCreateWantAd = "POSTWANTAD";
      const userActionCreateAgentInvtry = "CREATE_AGENT_INVENTORY";
      const userActionCreateMemberInvtry = "CREATE_MEMBER_INVENTORY";
      const userActionBrowseWantAd = "BROWSE_WANT_AD";
      const location = searchParams.get("location");
      if (location) {
        setLocalStorage("LocationString", location);
        navigate(pageURLs.home);
      }
      if (!userType) {
        let utmDtata = getLocalStorage("utmData");
        handleAgentOnboardingModal({
          showPopup: true,
          userAction:
            userAction === userActionLogin ? userActionLogin : userActionSignUp,
          utm_source: utmDtata?.utm_source,
          utm_medium: utmDtata?.utm_medium,
          utm_campaign: utmDtata?.utm_campaign,
        });
        if (userAction === userActionCreateWantAd) {
          setLocalStorage("userAction", userAction);
        }
        navigate(pageURLs.home);
      } else {
        if (userAction === userActionCreateWantAd) {
          if (userType === USER_TYPE_AGENT) {
            navigate(pageURLs.agentCreatewantad);
          } else {
            navigate(pageURLs.createwantad);
          }
        } else if (
          userAction === userActionCreateAgentInvtry ||
          userAction === userActionCreateMemberInvtry
        ) {
          if (userType === USER_TYPE_AGENT) {
            navigate(pageURLs.agentCreateInventory);
          } else {
            navigate(pageURLs.memberCreateInventory);
          }
        } else if (
          userAction === userActionLogin ||
          userAction === userActionSignUp ||
          userAction === userActionBrowseWantAd
        ) {
          navigate(pageURLs.home);
        }
      }
    } else if (showDeleteConfirmationModal) {
      setCheckEmailPopup(true);
    } else if (convertToNumber(action) === RESET_PWD_ACTION && userId) {
      if (userId) {
        handleResetPwdModal({
          showResetModal: true,
          resetPwdModalType: resetModalpwdOnly,
          token: gCode,
          action: action,
        });
      }
    } else if (convertToNumber(action) === EMAIL_VERIFICATION && userId) {
      const decryptedKey = decryption(userId);
      if (decryptedKey) {
        const reqPayload = {
          action: action,
          token: gCode,
          userId: decryptedKey,
          isEmailVerified: 1,
        };

        emailVerification(reqPayload);
      }
    } else {
      handleUserLogin();
    }
  }, [isMatch]);

  // This useeffect for managing the user to restrict click for want ads to 3 if not logged in
  useEffect(() => {
    if (wantAdClickCounter && wantAdClickCounter !== 0) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      const isVerified = _.get(userDetails, "userInfo.userIsVerified", null);
      const planStatus = _.get(userDetails, "userInfo.planStatus", null);
      const userStatus = _.get(userDetails, "userInfo.userStatus", null);
      if (!isVerified || !planStatus || !userStatus) {
        const wantAdArray = getLocalStorage(WANT_AD_ARRAY_KEY);
        if (wantAdArray && wantAdArray.length === 3) {
          handleAgentOnboardingModal({
            showPopup: isMatch ? true : false,
            userAction: SIGNUP,
          });
        }
      }
    }
  }, [wantAdClickCounter, isMatch]);

  const decryption = (value) => {
    const bytes = base64.decode(value);
    const decodedId = utf8.decode(bytes);
    if (decodedId) {
      const decodedData = decodedId.split("-");
      return decodedData.length > 0 ? decodedData[1] : null;
    }
    return null;
  };
  /**
   * To handle email verification
   * @param {*} reqPayload
   */
  const emailVerification = async (reqPayload) => {
    await userEmailVerification(reqPayload).then((response) => {
      if (response) {
        const errorCode = _.get(response, "errorCode", null);
        if (errorCode === 0) {
          toast.success("Email verified Successfully.");
          navigate(pageURLs.home);
        } else {
          toast.error("Something went wrong");
        }
      }
    });
  };

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
      if (userDetailsFromStore?.length === 1) {
        if (userDetailsFromStore[0]?.PlanName) {
          setUserPlan(userDetailsFromStore[0]?.PlanName);
        }
      } else {
        if (userDetailsFromStore[0]?.PlanName === "Trial") {
          setUserPlan(userDetailsFromStore[1]?.PlanName);
        } else {
          setUserPlan(userDetailsFromStore[0]?.PlanName);
        }
      }
      if (userDetailsFromStore[0]?.period !== 1 && getUserType() === 2) {
        setIsPremiumUser(true);
      } else {
        setIsPremiumUser(false);
      }
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  useEffect(() => {
    const payload = {
      PlanId: userDetails?.PlanId,
    };
    dispatch(fetchUserPrivileges(payload));
  }, [userDetails?.PlanId]);

  useEffect(() => {
    if (gCode && actionArray.includes(action)) {
      const reqPayLoad = {
        VerifyCode: gCode,
        Action: parseInt(action),
        IsVerified: 1,
      };

      try {
        verifyUserAction(reqPayLoad).then((response) => {
          if (response.errorCode === 0) {
            if (action === "8") {
              clearLocalStorage();
              navigate(pageURLs.home);
              toast.success("Account successfully deleted.");
            } else if (action === "5") {
              if (response?.result?.Status === "Confirmed") {
                handleEmailConfirmedModalOpen();
              } else {
                handleEmailVerifiedModalOpen();
              }
            } else if (action === "6") {
              clearLocalStorage();
              if (response?.result?.Status === "New_Email_Not_Verified") {
                setEmailNotVerified(true);
              } else {
                setEmailNotVerified(false);
              }
              handleEmailConfirmedModalOpen();
            } else if (action === "7") {
              clearLocalStorage();
              handleEmailChangeRevokedModalOpen();
            } else if (action === "9") {
              clearLocalStorage();
              toast.success("Account deletion revoked successfully.");
            }
          } else {
            toast.dismiss();
            toast.error(response.message);
          }
        });
      } catch (error) {
        toast.dismiss();
        toast.error(error);
      }
    }
  }, [action]);

  const handleUserTypeModal = ({ showModal }) => {
    setUserTypeModal(showModal);
  };

  const handleAgentTitleContinueClick = async () => {
    const reqPayload = {
      title: selectedTitle,
    };

    const res = await saveUserTypeAndTitle(reqPayload);
    if (_.get(res, "errorCode", "") === 0) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      userDetails.userInfo.agentTitle = convertToNumber(selectedTitle);
      setLocalStorage(USER_INFO_KEY, userDetails);
      handleAgentTitleModal({ showModal: false });
      PremiumPlanModalShow();
    } else {
      alert("Something went wrong.");
    }
  };

  const handleAgentTitleModal = ({ showModal }) => {
    setAgentTitleModal(showModal);
  };

  const saveUserTypeAndTitle = async (reqPayload) => {
    return await saveUserType_Title(reqPayload).then((response) => {
      return response;
    });
  };
  /**
   * To handle save user type on user onboarding
   */
  const handleUserTypeContinueClick = async () => {
    const selectedUserType =
      userType || _.get(userData, "userInfo.userType", null);
    const reqPayload = {
      userTypeId: selectedUserType,
    };

    const res = await saveUserTypeAndTitle(reqPayload);

    if (_.get(res, "errorCode", "") === 0) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      userDetails.userInfo.userType = convertToNumber(selectedUserType);
      setLocalStorage(USER_INFO_KEY, userDetails);
      handleUserTypeModal({ showModal: false });
      if (convertToNumber(selectedUserType) === USER_TYPE_AGENT) {
        handleAgentTitleModal({ showModal: true });
      } else {
        BasicPlanModalShow();
      }
    } else {
      alert("Something went wrong.");
    }
  };
  /**
   * To handle save member user details
   * @param {*} firstName
   * @param {*} lastName
   */
  const handlMemberProfileContinue = async (firstName, lastName) => {
    const reqPayload = {
      firstName: firstName,
      lastName: lastName,
    };

    const res = await changeUserName(reqPayload);
    const name = firstName + " " + lastName;
    if (_.get(res, "errorCode", "") === 0) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      if (userDetails) {
        userDetails.userInfo.userStatus = true;
        userDetails.userInfo.firstName = firstName;
        userDetails.userInfo.lastName = lastName;
        userDetails.userInfo.name = name;
      }
      setLocalStorage(USER_INFO_KEY, userDetails);
      handleMemberProfileModal({ showModal: false });
      // setAgentPreferenceModal(true);
      triggerOnboarding();
    } else {
      alert("Something went wrong.");
    }
  };

  const handleResetPwdModal = ({
    showResetModal,
    resetPwdModalType,
    userId,
    token = "",
    action = "",
  }) => {
    handleAgentOnboardingModal({
      showPopup: false,
      userAction: LOGIN,
    });
    setResetModalType(resetPwdModalType);
    setResetPwdModal({
      showResetModal: showResetModal,
      userId: userId,
      token: token,
      action: convertToNumber(action),
    });
  };

  const handleAgentPreferenceContinue = (clickedButton) => {
    if (clickedButton === "Continue") {
      setLocalStorage("tutorialOnSignUp", 1);
      if (agentPreference === WANT_AD) {
        if (DisplayWantAddOnboard) {
          navigate(pageURLs.gitchaMemberWelcome);
        } else {
          navigate(pageURLs.agentCreatewantad);
        }
      } else {
        if (DisplayInventoryAddOnboard) {
          navigate(pageURLs.gitchaInvetoryOnBoard);
        } else {
          navigate(pageURLs.agentCreateInventory);
        }
      }
    } else {
      setAgentPreferenceModal(false);
    }
  };

  const handleAgentOnboardingModal = (params) => {
    const userPreference = _.get(params, "userPreference", null);
    if (userPreference) {
      setUserPreference(userPreference);
    } else {
      setUserPreference(HOME);
    }
    setAgentOnboardingPopup((prevData) => ({ ...prevData, params }));
  };

  const handleAgentPrefernceModal = (showState) => {
    setAgentPreferenceModal(showState);
  };

  const handleAgentPrefernceBack = () => {
    setAgentPreferenceModal(false);
    setAgentProfileModal(true);
  };

  const handleShowAgentModal = ({ showState }) => {
    setAgentProfileModal(showState);
  };

  const handleMemberProfileModal = ({ showModal }) => {
    setMemberProfileModal(showModal);
  };

  const handleEmailVerifiedModalClose = () => {
    setShowEmailVerifiedmodal(false);
  };

  const handleEmailVerifiedModalOpen = () => {
    setShowEmailVerifiedmodal(true);
  };

  const handleEmailConfirmedModalClose = () => {
    setShowEmailConfirmedModal(false);
  };

  const handleEmailConfirmedModalOpen = () => {
    setShowEmailConfirmedModal(true);
  };

  const handleEmailChangeRevokedModalClose = () => {
    setShowEmailChangeRevokedModal(false);
  };

  const handleEmailChangeRevokedModalOpen = () => {
    setShowEmailChangeRevokedModal(true);
  };

  const handleCheckEmailDeletionModalClose = () => {
    setCheckEmailPopup(false);
    navigate(pageURLs.home, {});
    window.location.reload();
  };

  const resetPassWord = async (params) => {
    const email = _.get(params, "email", null);
    if (email) {
      return await resetPassword(params).then((response) => {
        if (response) {
          const resResult = _.get(response, "result", null);
          if (_.get(response, "errorCode", null) === 0) {
            setResetEmailState(true);
            setResetPwdModal({ showResetModal: false });
            setEmail(email);
          } else {
            return { isVerified: false, message: response?.message };
          }
        }
        return { isVerified: false, message: "something went wrong." };
      });
    } else {
      return await updatePassword(params)
        .then((response) => {
          if (response) {
            if (_.get(response, "errorCode", "") === 0) {
              setResetPwdModal({ showResetModal: false });
              if (isFromSettings) {
                toast.success("Password changed successfully.");
              } else {
                handleAgentOnboardingModal({
                  showPopup: true,
                  userAction: LOGIN,
                });
                toast.success(
                  "Password changed successfully, please login again.",
                );
              }
            } else {
              return response;
            }
          }
          return null;
        })
        .catch((err) => {
          //TODO HANDLE THE ERROR CODE KEEPING THE MESSAGE STATIC AS OF NOW
          toast.error(`${err.response.data.message}`);
        });
    }
  };

  const excludedUrls = [pageURLs.wantAdPubicDetailsPage];

  const handleUserLogin = () => {
    const userDetails = getLocalStorage(USER_INFO_KEY);
    const userType = _.get(userDetails, "userInfo.userType", null);
    const agentTitle = _.get(userDetails, "userInfo.agentTitle", null);
    const isVerified = _.get(userDetails, "userInfo.userIsVerified", null);
    const planStatus = _.get(userDetails, "userInfo.planStatus", null);
    const userStatus = _.get(userDetails, "userInfo.userStatus", null);
    const userActionForwarded = getLocalStorage("userAction");

    if (userDetails?.userInfo) {
      if (userType) {
        if (isVerified && planStatus && userStatus) {
          if (userActionForwarded === "POSTWANTAD") {
            if (userType === USER_TYPE_AGENT) {
              navigate(pageURLs.agentCreatewantad);
            } else {
              navigate(pageURLs.createwantad);
            }
          } else {
            removeLocalStorage(WANT_AD_ARRAY_KEY);
            if (userPreference && userPreference === POST_WANT_AD) {
              navigate(pageURLs.agentCreatewantadMainScreen);
            } else if (userPreference && userPreference === HOME) {
              navigate(pageURLs.home);
              // window.location.reload();
            }
          }
        } else {
          if (convertToNumber(userType) === USER_TYPE_AGENT) {
            if (!agentTitle) {
              handleAgentTitleModal({ showModal: true });
            } else if (!planStatus) {
              PremiumPlanModalShow();
            } else if (!userStatus) {
              handleShowAgentModal({ showState: true });
            }
          } else {
            if (!planStatus) {
              BasicPlanModalShow();
            } else if (!userStatus) {
              handleMemberProfileModal({ showModal: true });
            }
          }
        }
      } else {
        handleUserTypeModal({ showModal: true });
      }
    } else {
      const pathName = _.get(location, "pathname", null)?.toLowerCase();
      if (!_.includes(excludedUrls, pathName)) {
        let utmDtata = getLocalStorage("utmData");
        if (
          !pathName.startsWith("/want-ad-details") &&
          !pathName.startsWith("/agent-info") &&
          pathName !== `/want-ad/${pageURLs.deletedWantAd}`
        )
          handleAgentOnboardingModal({
            showPopup: isMatch ? true : false,
            userAction: SIGNUP,
            userPreference: HOME,
            utm_source: utmDtata?.utm_source,
            utm_medium: utmDtata?.utm_medium,
            utm_campaign: utmDtata?.utm_campaign,
          });
        if (
          pathName !== "/home" &&
          pathName !== `/want-ad/${pageURLs?.deletedWantAd}` &&
          !pathName.startsWith("/want-ad-details") &&
          !pathName.startsWith("/agent-info")
        ) {
          navigate(pageURLs?.home);
        }
      }
    }
  };

  const updateIntroStateonHover = async (introId) => {
    let introIds = []; // This is for bulk updating, ie user select 'mark as read all' option.
    let readType = 1;
    if (!introId) {
      readType = 2;
    } else {
      introIds.push(introId);
      readType = 1;
    }
    await updateIntroShowStatus(
      introIds,
      readType,
      _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", ""),
    ).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          if (introId) {
            const updatedIntro = introductionList.filter(
              (lst) => lst.IntroductionId === introId,
            );
            if (updatedIntro) {
              updatedIntro[0].ReadStatus = 1;
            }
            const RemainingIntro = introductionList.filter(
              (lst) => lst.IntroductionId !== introId,
            );
            setIntroductionList([...updatedIntro, ...RemainingIntro]);
            setUnreadMessageCount(unreadMessageCount - 1);
          } else {
            const introListCopy = introductionList;
            for (var i = 0; i < introListCopy.length; i++) {
              if (introListCopy[i].ReadStatus === 0) {
                introListCopy[i].ReadStatus = 1;
              }
            }
            setIntroductionList([...introListCopy]);
            setUnreadMessageCount(0);
          }
        } else {
          console.log("Something went wrong");
        }
      }
    });
  };

  useEffect(() => {
    const wantAdId = null;
    currPage !== 1 && getIntroductionList(currPage, wantAdId);
  }, [currPage]);

  // to load the receive intro number
  useEffect(() => {
    const wantAdId = null;
    getIntroductionList(currPage, wantAdId);
  }, []);

  const updateIntroPageOnScroll = () => {
    setCurrPage((prevState) => prevState + 1);
  };

  const handleCloseIntroList = () => {
    setIntroList(false);
  };

  const getIntroductionList = async (
    page,
    wantAdId,
    isHandShakeClick = false,
  ) => {
    setLoadIntroList(false);
    const reqPayload = {
      wantAdId: wantAdId,
      page: page,
      limit: INTRO_LIST_PAGE_LIMIT,
      isAccept: "1",
    };
    await getIntroductions(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        if (response.errorCode === 0) {
          if (isHandShakeClick) {
            setIntroductionList(list);
            if (_.get(response, "result.unReadMessageCount", null) == 0) {
              setLocalStorage(NOTIFICATIONCOUNT, {
                count: _.get(response, "result.unReadMessageCount", null),
              });
            }
            setUnreadMessageCount(
              _.get(response, "result.unReadMessageCount", 0),
            );
          } else {
            setIntroductionList([...introductionList, ...list]);
            if (_.get(response, "result.unReadMessageCount", null) == 0) {
              setLocalStorage(NOTIFICATIONCOUNT, {
                count: _.get(response, "result.unReadMessageCount", null),
              });
            }
            setUnreadMessageCount(
              _.get(response, "result.unReadMessageCount", 0),
            );
          }
          setLoadIntroList(true);
        } else {
          setLoadIntroList(true);
          console.log(`####error`);
        }
      }
    });
  };

  const handleHandShakeClick = () => {
    const wantAdId = null;
    const isHandShakeClick = true;
    const page = 1;
    setCurrPage(1);
    getIntroductionList(page, wantAdId, isHandShakeClick);
  };

  useEffect(() => {
    unreadNotificationMessageCount > 0 &&
      setLocalStorage(INAPPNOTIFICATIONCOUNT, {
        count: unreadNotificationMessageCount,
      });
    unreadMessageCount > 0 &&
      setLocalStorage(NOTIFICATIONCOUNT, { count: unreadMessageCount });
  }, [unreadNotificationMessageCount, unreadMessageCount]);

  const getNotificationList = async () => {
    setLoadNotificationList(false);
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    const reqPayload = {
      userId: userId,
    };
    await getInAppNotications().then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);

        if (response.errorCode === 0) {
          setNotificationList(list);
          if (_.get(response, "result.unReadMessageCount", null) == 0) {
            setLocalStorage(INAPPNOTIFICATIONCOUNT, {
              count: _.get(response, "result.unReadMessageCount", null),
            });
          }
          setUnreadNotificationMessageCount(
            _.get(response, "result.unReadMessageCount", null),
          );

          dispatch(
            setInappNotificationCount(
              _.get(response, "result.unReadMessageCount", 0),
            ),
          );

          setLoadNotificationList(true);
        } else {
          setLoadNotificationList(true);
        }
      }
    });
  };

  const updateInAppStatusonHover = async () => {
    setDeleteNotificationModal(false);
    setWantAdRenewModal(false);
    await updateInAppReadStatus().then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          setUnreadNotificationMessageCount(0);
          getNotificationList();
        } else {
          console.log("Something went wrong");
        }
      }
    });
  };

  const updateInAppDeleteStatusOnClick = async (
    notificationId = null,
    subjectType,
    deleteStatus = true,
    deleteType = 2,
  ) => {
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    await updateInAppDeleteStatus(
      notificationId,
      deleteStatus,
      deleteType,
      subjectType,
    ).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          if (deleteType == 1) {
            // single delete
            const RemainingNotification = notificationList.filter(
              (lst) => lst.NotificationId !== notificationId,
            );
            setNotificationList([...RemainingNotification]);
          } else {
            setDeleteNotificationModal(false);
            setNotificationList([]);
            setUnreadNotificationMessageCount(0);
          }

          if (deleteStatus == true && deleteType == 1) {
            toast.dismiss();
            setTimeout(() => {
              toast.success(
                toastCustomMessage(
                  notificationId,
                  subjectType,
                  deleteStatus,
                  deleteType,
                ),
              );
            }, 10);
          } else if (deleteStatus == false && deleteType == 1) {
            getNotificationList();
          }
        }
      }
    });
  };

  const toastCustomMessage = (
    notificationId,
    subjectType,
    deleteStatus,
    deleteType,
  ) => {
    return (
      <div className="d-flex align-items-center justify-content-between">
        <span className="d-flex flex-grow-1">Notification deleted</span>

        <button
          variant=""
          className="btn-primary text-nowrap me-2"
          onClick={() => {
            updateInAppDeleteStatusOnClick(
              notificationId,
              subjectType,
              !deleteStatus,
              deleteType,
            );
          }}
        >
          {" "}
          Undo
        </button>
      </div>
    );
  };

  const onDeleteInappNotification = () => {
    setDeleteNotificationModal(true);
  };

  const onConfirmReniewWantAdClicked = async () => {
    if (wantAdForRenew?.Want_ad_Id) {
      if (
        (wantAdForRenew?.Buy_or_Rent == 2 &&
          wantAdForRenew?.Move_in_TimeLine == 11) ||
        wantAdForRenew?.Buy_or_Rent == 3
      ) {
        await getWantAdById(wantAdForRenew?.Want_ad_Id)
          .then((response) => {
            const responseResult = _.get(response, "result", null);
            if (response.errorCode === 0 && responseResult) {
              if (responseResult.isAgentCreated == 1) {
                navigate("/agent-create-want-ad", {
                  state: { data: responseResult, isFromNotification: true },
                });
              } else {
                navigate("/edit-want-ad", { state: { data: responseResult } });
              }
            } else {
              console.log("Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      } else {
        await unArchiveWantAd(wantAdForRenew?.Want_ad_Id)
          .then((response) => {
            if (response.errorCode == 0) {
              setWantAdRenewModal(false);
              getNotificationList();
              if (
                wantAdForRenew?.IsArchived ||
                wantAdForRenew?.IsAutoArchived
              ) {
                toast.success(
                  "Your paused want-listing has been made public again.",
                );
              } else {
                toast.success(
                  "Your want-listing has been successfully renewed.",
                );
              }
            } else {
              console.log("Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      }
    }
  };
  const renewWantAd = async (notification) => {
    if (notification?.wantDeleted) {
      toast.success("Your want-listing has already been deleted.");
    } else if (notification?.Expiry_Status) {
      toast.success("Your want-listing already been renewed.");
    } else {
      setWantAdForReniew(notification);
      setWantAdRenewModal(true);
    }
  };

  const headerButtons = () => {
    return (
      user && (
        <div className="toplinks d-flex">
          <Dropdown
            className="introduction-btn position-relative"
            autoClose={true}
            onClick={() => {
              handleHandShakeClick();
              setDeleteNotificationModal(false);
            }}
          >
            <Dropdown.Toggle
              id="dropdown-basic56"
              className="ml-6 mr-6 common-links handshake-icon border-0 p-0"
              variant=""
              align="end"
            >
              {(_.get(getLocalStorage(NOTIFICATIONCOUNT), "count", "") > 0 ||
                unreadMessageCount > 0) && (
                <span className="position-absolute top-4 start-88 translate-middle badge rounded-pill notification-bg-red txt-display">
                  {unreadMessageCount
                    ? unreadMessageCount
                    : _.get(getLocalStorage(NOTIFICATIONCOUNT), "count", "")}
                  <span className="visually-hidden">unread messages</span>
                </span>
              )}
              handshake
            </Dropdown.Toggle>
            <Dropdown.Menu align={"end"} data-bs-popper="none">
              <Introductions
                list={introductionList}
                updateIntroStateonHover={updateIntroStateonHover}
                updateIntroPageOnScroll={updateIntroPageOnScroll}
                isLoadIntroList={isLoadIntroList}
                handleCloseIntroList={handleCloseIntroList}
              />
            </Dropdown.Menu>
          </Dropdown>

          {/* ********************In-app notificationList********************** */}
          <Dropdown
            className="notification-btn position-relative"
            autoClose={true}
            onClick={() => {
              updateInAppStatusonHover();
            }}
          >
            <Dropdown.Toggle
              id="dropdown-basic56"
              className="ml-6 mr-6 common-links bell-icon border-0 position-relative p-0"
              variant=""
            >
              {(_.get(getLocalStorage(INAPPNOTIFICATIONCOUNT), "count", "") >
                0 ||
                unreadNotificationMessageCount > 0 ||
                unreadInappNotificationCount > 0) && (
                <span className="position-absolute top-4 start-88 translate-middle badge rounded-pill notification-bg-red txt-display">
                  {unreadNotificationMessageCount
                    ? unreadNotificationMessageCount
                    : unreadInappNotificationCount
                      ? unreadInappNotificationCount
                      : _.get(
                          getLocalStorage(INAPPNOTIFICATIONCOUNT),
                          "count",
                          "",
                        )}
                  <span className="visually-hidden">unread messages</span>
                </span>
              )}
              bell
            </Dropdown.Toggle>
            <Dropdown.Menu align={"end"} data-bs-popper="none" className="">
              <div
                className={
                  deleteNotificationModal
                    ? "w-100 mh-365 position-relative notif-modal-container"
                    : "w-100 h-100 position-relative notif-modal-container"
                }
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Notifications
                  list={notificationList}
                  isLoadNotificationList={isLoadNotificationList}
                  onDeleteInappNotification={() => onDeleteInappNotification()}
                  updateInAppDeleteStatusOnClick={
                    updateInAppDeleteStatusOnClick
                  }
                  renewWantAd={(notification) => {
                    renewWantAd(notification);
                  }}
                />

                <DeleteNotificationModalNew
                  show={deleteNotificationModal}
                  onHide={handleDeleteNotificationPopupClose}
                  onConfirm={updateInAppDeleteStatusOnClick}
                />

                {/* for want reniew confirmation */}
                <WantAdRenewConfirmationModal
                  show={wantAdRenewModal}
                  onHide={handleWantAdRenewPopupClose}
                  onConfirmReniewWantAd={onConfirmReniewWantAdClicked}
                />
              </div>
            </Dropdown.Menu>
          </Dropdown>
          {/* ********************In-app notificationList********************** */}

          <a
            className="nav-link common-links ml-6 mr-6 chat-icon"
            aria-current="page"
            onClick={() => navigate("/messages")}
          >
            chat
          </a>
          {/* DIRECT MESSAGES */}
          {/* <a
            className="nav-link common-links ml-6 mr-6 direct-chat-icon"
            aria-current="page"
            onClick={() => navigate("/direct-messages")}
          >
            Direct Message
          </a> */}
        </div>
      )
    );
  };

  const handleTitleClick = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      setTitle(selectedValue);
      setTitleButtonState(true);
    } else {
      setTitleButtonState(false);
    }
  };

  const handleUserTypeSelection = (e) => {
    const selectedValue = e.target.value;
    setUserType(selectedValue);
  };

  const handlePreferenceSelection = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      setAgentPreference(selectedValue);
    }
  };

  const saveAgentDetails = async (agentDetails) => {
    const userId =
      _.get(user, "userInfo.userId", null) ||
      _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);
    const firstName = _.get(agentDetails, "firstName", "");
    const lastName = _.get(agentDetails, "lastName", "");
    const name = firstName + " " + lastName;
    const agentInfo = {
      FirstName: firstName,
      LastName: lastName,
      Phone: _.get(agentDetails, "phone", ""),
      Location: _.get(agentDetails, "location", ""),
      Company: _.get(agentDetails, "company", ""),
      LicenseNo: _.get(agentDetails, "licenseNo", ""),
      Bio: _.get(agentDetails, "bio", ""),
      Img: _.get(agentDetails, "img", ""),
      facebookUrl: _.get(agentDetails, "facebookUrl", ""),
      instagramUrl: _.get(agentDetails, "instagramUrl", ""),
      websiteUrl: _.get(agentDetails, "websiteUrl", ""),
      logoUrl: _.get(agentDetails, "logoUrl", ""),
      clientTestimonial: _.get(agentDetails, "clientTestimonial", ""),
      youtubeUrl: _.get(agentDetails, "youtubeUrl", ""),
    };
    await saveAgentInfo(agentInfo).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          const userDetails = getLocalStorage(USER_INFO_KEY);
          if (userDetails) {
            userDetails.userInfo.userStatus = true;
            userDetails.userInfo.firstName = firstName;
            userDetails.userInfo.lastName = lastName;
            userDetails.userInfo.name = name;
            userDetails.userInfo.image = _.get(agentDetails, "img", "");
          }
          setLocalStorage(USER_INFO_KEY, userDetails);
          // setAgentPreferenceModal(true); disabled for userpilot
          triggerOnboarding();
          setAgentProfileModal(false);
        } else {
          console.log("Something went wrong");
        }
      }
    });
  };

  const handleLogOut = () => {
    clearLocalStorageOnLogout();
    signOutFirebase();
    setTimeout(() => {
      navigate(0);
    }, 300);
  };

  useEffect(() => {
    if (props.tutorialAccept) {
      setAgentMenuNotificationIcon(false);
    }
  }, [props.tutorialAccept]);

  //Show red icon against Agent dashboard only if Agent have at least one count
  useEffect(() => {
    if (
      showAgentIcon === true &&
      sessionData &&
      sessionData?.userInfo?.ClientCount > 0
    ) {
      setAgentMenuNotificationIcon(true);
    }
  }, [sessionData, sessionData?.userInfo?.ClientCount]);

  return (
    <div className="top-header top-header-bg mb-24">
      <div className="w-100 h-100 d-flex p-0 flex-column flex-sm-column flex-md-row justify-content-between align-items-center">
        <div className="d-flex align-items-center align-items-md-start align-items-lg-end flex-column flex-lg-row">
          <div className="navbar-brand p-0 me-lg-3">
            <a
              href={void 0}
              className="d-block"
              onClick={() => {
                navigate("/home");
                if (props.fromHome) {
                  redirectToHomePage();
                }
              }}
            >
              <img src={GitchaLogo} alt={GitchaLogo} />
            </a>
          </div>
          <div className="brand-tagline mb-3 mb-md-0 mt-1 mt-lg-0 cust-fsize-small">
            {getUserType() == USER_TYPE_AGENT ? (
              <>
                The Buyer Listing Service<sup>®</sup>
              </>
            ) : (
              "The “Want” Marketplace for Real Estate"
            )}
          </div>
        </div>

        <ul className="d-flex flex-row navbar-nav flex-column flex-md-row">
          <li className="nav-item d-flex flex-row justify-content-center mb-3 mb-md-0">
            {headerButtons()}
          </li>

          <li className="nav-item d-flex flex-row">
            <div className="top-btn-wrap d-flex">
              {props.fromHome && (
                <Button
                  variant="primary"
                  onClick={() => handleCanvasShow()}
                  className="hamburger mr-6"
                >
                  Filter
                </Button>
              )}
              {currentURL !== pageURLs?.agentCreatewantad &&
                currentURL !== pageURLs?.agentEditwantad &&
                _.get(user, "userInfo.userType", "") === USER_TYPE_AGENT && (
                  <Button
                    variant={
                      user && Object.keys(_.get(user, "userInfo", {})).length
                        ? "primary"
                        : "secondary"
                    }
                    className="ml-6 mr-2 btn-tweak"
                    onClick={() => {
                      _.get(user, "userInfo", null)
                        ? DisplayWantAddOnboard
                          ? navigate(pageURLs.gitchaMemberWelcome)
                          : navigate(pageURLs.agentCreatewantadMainScreen)
                        : handleAgentOnboardingModal({
                            showPopup: true,
                            userAction: SIGNUP,
                            userPreference: POST_WANT_AD,
                          });
                    }}
                  >
                    Post Want-Listing
                  </Button>
                )}
              {user &&
              Object.keys(_.get(user, "userInfo", {})).length &&
              _.get(user, "userInfo.planStatus", false) &&
              _.get(user, "userInfo.userStatus", false) ? (
                <div className="toplinks">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant=""
                      id="dropdown-basic"
                      className="profile-img profile-bg-green ml-6"
                    >
                      {" "}
                      {_.get(user, "userInfo.image", "") &&
                      _.get(user, "userInfo.userType", "") == USER_TYPE_AGENT &&
                      isPremiumUser ? (
                        <>
                          <img
                            className="brdr-rs-200"
                            src={
                              _.get(user, "userInfo.image", "") +
                              "?" +
                              Math.random().toString(36)
                            }
                            alt=""
                          />
                        </>
                      ) : (
                        <>
                          {_.get(user, "userInfo.name", "")
                            .replace(/-/g, "")
                            .match(/\b(\w)/g)}
                        </>
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => navigate(pageURLs.settings)}
                      >
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.0001 3.125C7.58386 3.125 5.6251 5.08375 5.6251 7.5C5.6251 9.91625 7.58386 11.875 10.0001 11.875C12.4164 11.875 14.3751 9.91625 14.3751 7.5C14.3751 5.08375 12.4164 3.125 10.0001 3.125ZM4.3751 7.5C4.3751 4.3934 6.8935 1.875 10.0001 1.875C13.1067 1.875 15.6251 4.3934 15.6251 7.5C15.6251 10.6066 13.1067 13.125 10.0001 13.125C6.8935 13.125 4.3751 10.6066 4.3751 7.5Z"
                              fill="#15181E"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.0001 13.1243C8.57374 13.1243 7.17251 13.4998 5.93728 14.213C4.70205 14.9263 3.67634 15.9521 2.96327 17.1875C2.79071 17.4864 2.40848 17.5889 2.10953 17.4163C1.81058 17.2437 1.70812 16.8615 1.88068 16.5626C2.70345 15.1372 3.88696 13.9535 5.31223 13.1305C6.7375 12.3076 8.3543 11.8743 10.0001 11.8743C11.6459 11.8743 13.2627 12.3076 14.688 13.1305C16.1132 13.9535 17.2968 15.1372 18.1195 16.5626C18.2921 16.8615 18.1896 17.2437 17.8907 17.4163C17.5917 17.5889 17.2095 17.4864 17.0369 17.1875C16.3239 15.9521 15.2982 14.9263 14.0629 14.213C12.8277 13.4998 11.4265 13.1243 10.0001 13.1243Z"
                              fill="#15181E"
                            />
                          </svg>
                        </span>
                        Account
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() =>
                          _.get(user, "userInfo.userType", "") ==
                            USER_TYPE_AGENT && isPremiumUser
                            ? navigate("/favorite-clients")
                            : navigate("/my-favorites")
                        }
                      >
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.75312 4.35487C7.0517 3.98137 6.24254 3.86242 5.4633 4.01827C4.68407 4.17412 3.9829 4.59513 3.47909 5.20968C2.97528 5.82423 2.69995 6.59435 2.69995 7.38901C2.69995 9.7576 4.46368 12.0183 6.3993 13.7604C7.34821 14.6144 8.29998 15.3095 9.01582 15.7915C9.37314 16.0321 9.67017 16.2186 9.87668 16.3442C9.8803 16.3464 9.88389 16.3486 9.88745 16.3508C9.89101 16.3486 9.89461 16.3464 9.89823 16.3442C10.1047 16.2186 10.4018 16.0321 10.7591 15.7915C11.4749 15.3095 12.4267 14.6144 13.3756 13.7604C15.3112 12.0183 17.075 9.7576 17.075 7.38901C17.075 6.59435 16.7996 5.82423 16.2958 5.20968C15.792 4.59513 15.0908 4.17412 14.3116 4.01827C13.5324 3.86242 12.7232 3.98137 12.0218 4.35487C11.3204 4.72837 10.77 5.33336 10.4644 6.0669C10.3673 6.2998 10.1398 6.45151 9.88745 6.45151C9.63514 6.45151 9.40757 6.2998 9.31053 6.0669C9.00489 5.33336 8.45454 4.72837 7.75312 4.35487ZM9.88745 17.0765C9.58207 17.6218 9.58191 17.6217 9.58171 17.6216L9.57954 17.6204L9.57418 17.6174L9.55514 17.6066C9.53882 17.5972 9.5153 17.5837 9.48506 17.5661C9.4246 17.5309 9.33725 17.4792 9.22684 17.4121C9.0061 17.2777 8.69277 17.0809 8.31767 16.8283C7.56868 16.324 6.56731 15.5933 5.5631 14.6895C3.59248 12.916 1.44995 10.3329 1.44995 7.38901C1.44995 6.30538 1.8254 5.25521 2.51241 4.41719C3.19942 3.57917 4.15556 3.00506 5.21816 2.79254C6.28075 2.58002 7.38415 2.74222 8.34063 3.25155C8.95128 3.57671 9.47796 4.03054 9.88745 4.57651C10.2969 4.03054 10.8236 3.57671 11.4343 3.25155C12.3907 2.74222 13.4942 2.58002 14.5567 2.79254C15.6193 3.00506 16.5755 3.57917 17.2625 4.41719C17.9495 5.25521 18.325 6.30538 18.325 7.38901C18.325 10.3329 16.1824 12.916 14.2118 14.6895C13.2076 15.5933 12.2062 16.324 11.4572 16.8283C11.0821 17.0809 10.7688 17.2777 10.5481 17.4121C10.4377 17.4792 10.3503 17.5309 10.2898 17.5661C10.2596 17.5837 10.2361 17.5972 10.2198 17.6066L10.2007 17.6174L10.1954 17.6204L10.1937 17.6213C10.1935 17.6214 10.1928 17.6218 9.88745 17.0765ZM9.88745 17.0765L10.1928 17.6218C10.0031 17.7281 9.77143 17.7279 9.58171 17.6216L9.88745 17.0765Z"
                              fill="#15181E"
                            />
                          </svg>
                        </span>
                        Favorites
                      </Dropdown.Item>
                      {userDetails?.period === 1 && (
                        <Dropdown.Item
                          onClick={() =>
                            _.get(user, "userInfo.userType", "") ==
                            USER_TYPE_AGENT
                              ? PremiumPlanModalShow()
                              : BasicPlanModalShow()
                          }
                        >
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                            >
                              <defs>
                                <clipPath id="a">
                                  <rect width="20" height="20" fill="#fff" />
                                </clipPath>
                              </defs>
                              <g clip-path="url(#a)">
                                <path
                                  d="M16.385,11.269a1.233,1.233,0,0,1-.814,1.167l-4.035,1.484-1.484,4.032a1.244,1.244,0,0,1-2.334,0L6.229,13.926,2.2,12.441a1.244,1.244,0,0,1,0-2.334L6.231,8.622,7.715,4.59a1.244,1.244,0,0,1,2.334,0l1.484,4.035,4.032,1.484a1.233,1.233,0,0,1,.819,1.159Zm-4.375-7.5h1.25v1.25a.625.625,0,1,0,1.25,0V3.769h1.25a.625.625,0,1,0,0-1.25H14.51V1.269a.625.625,0,0,0-1.25,0v1.25H12.01a.625.625,0,0,0,0,1.25Zm6.875,2.5H18.26V5.644a.625.625,0,0,0-1.25,0v.625h-.625a.625.625,0,0,0,0,1.25h.625v.625a.625.625,0,1,0,1.25,0V7.519h.625a.625.625,0,1,0,0-1.25Z"
                                  transform="translate(-0.383 0.356)"
                                  fill="#234d93"
                                />
                              </g>
                            </svg>
                          </span>
                          Upgrade to{" "}
                          {getUserType() === USER_TYPE_AGENT
                            ? "Pro Member"
                            : "Member"}
                        </Dropdown.Item>
                      )}
                      <Dropdown.Divider />
                      {_.get(user, "userInfo.userType", "") ===
                        USER_TYPE_AGENT &&
                        userDetails?.period &&
                        userDetails?.period !== NOT_FREE_OR_MEMBER_PERIOD && (
                          <Dropdown.Item
                            onClick={() => navigate("/agent-dashboard")}
                            className="position-relative"
                          >
                            {showAgentMenuNotificationIcon && (
                              <div className="ring-container-db">
                                <div className="circlebtn">
                                  <div className="ringring"></div>
                                </div>
                              </div>
                            )}
                            <span>
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.49922 13.625C6.5649 13.6744 6.63968 13.7103 6.71926 13.7307C6.79885 13.7512 6.88169 13.7557 6.96303 13.7441C7.04437 13.7325 7.12263 13.705 7.19332 13.6631C7.26401 13.6212 7.32575 13.5658 7.375 13.5C7.75341 12.9955 8.24409 12.5859 8.8082 12.3039C9.3723 12.0218 9.99432 11.875 10.625 11.875C11.2557 11.875 11.8777 12.0218 12.4418 12.3039C13.0059 12.5859 13.4966 12.9955 13.875 13.5C13.9242 13.5657 13.9859 13.621 14.0566 13.6628C14.1272 13.7046 14.2054 13.7321 14.2866 13.7437C14.3679 13.7553 14.4506 13.7508 14.5301 13.7304C14.6096 13.7101 14.6843 13.6742 14.75 13.625C14.8157 13.5758 14.871 13.5141 14.9128 13.4434C14.9546 13.3728 14.9821 13.2946 14.9937 13.2134C15.0053 13.1321 15.0008 13.0494 14.9804 12.9699C14.9601 12.8904 14.9242 12.8157 14.875 12.75C14.3216 12.008 13.5836 11.4238 12.7344 11.0555C13.1998 10.6306 13.5258 10.0749 13.6697 9.4614C13.8137 8.84789 13.7688 8.2052 13.5409 7.61767C13.313 7.03014 12.9129 6.52523 12.3929 6.1692C11.873 5.81316 11.2575 5.62265 10.6273 5.62265C9.99718 5.62265 9.38173 5.81316 8.86178 6.1692C8.34182 6.52523 7.94166 7.03014 7.71379 7.61767C7.48593 8.2052 7.44102 8.84789 7.58495 9.4614C7.72888 10.0749 8.05493 10.6306 8.52031 11.0555C7.6694 11.4231 6.92972 12.0074 6.375 12.75C6.27546 12.8825 6.23263 13.0491 6.25592 13.2132C6.27922 13.3773 6.36673 13.5254 6.49922 13.625ZM8.75 8.75C8.75 8.37916 8.85997 8.01665 9.06599 7.70831C9.27202 7.39996 9.56486 7.15964 9.90747 7.01773C10.2501 6.87581 10.6271 6.83868 10.9908 6.91103C11.3545 6.98337 11.6886 7.16195 11.9508 7.42417C12.213 7.6864 12.3916 8.02049 12.464 8.38421C12.5363 8.74792 12.4992 9.12492 12.3573 9.46753C12.2154 9.81014 11.975 10.103 11.6667 10.309C11.3584 10.515 10.9958 10.625 10.625 10.625C10.1277 10.625 9.65081 10.4275 9.29917 10.0758C8.94754 9.72419 8.75 9.24728 8.75 8.75ZM16.25 1.875H5C4.66848 1.875 4.35054 2.0067 4.11612 2.24112C3.8817 2.47554 3.75 2.79348 3.75 3.125V5H2.5C2.33424 5 2.17527 5.06585 2.05806 5.18306C1.94085 5.30027 1.875 5.45924 1.875 5.625C1.875 5.79076 1.94085 5.94973 2.05806 6.06694C2.17527 6.18415 2.33424 6.25 2.5 6.25H3.75V9.375H2.5C2.33424 9.375 2.17527 9.44085 2.05806 9.55806C1.94085 9.67527 1.875 9.83424 1.875 10C1.875 10.1658 1.94085 10.3247 2.05806 10.4419C2.17527 10.5592 2.33424 10.625 2.5 10.625H3.75V13.75H2.5C2.33424 13.75 2.17527 13.8158 2.05806 13.9331C1.94085 14.0503 1.875 14.2092 1.875 14.375C1.875 14.5408 1.94085 14.6997 2.05806 14.8169C2.17527 14.9342 2.33424 15 2.5 15H3.75V16.875C3.75 17.2065 3.8817 17.5245 4.11612 17.7589C4.35054 17.9933 4.66848 18.125 5 18.125H16.25C16.5815 18.125 16.8995 17.9933 17.1339 17.7589C17.3683 17.5245 17.5 17.2065 17.5 16.875V3.125C17.5 2.79348 17.3683 2.47554 17.1339 2.24112C16.8995 2.0067 16.5815 1.875 16.25 1.875ZM16.25 16.875H5V3.125H16.25V16.875Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                            Agent dashboard
                          </Dropdown.Item>
                        )}

                      {_.get(user, "userInfo.userType", "") ===
                        USER_TYPE_MEMBER &&
                        userPlan === INVESTOR_MEMBER_PLAN && (
                          <Dropdown.Item
                            onClick={() => navigate("/investor-dashboard")}
                            className="position-relative"
                          >
                            {showAgentMenuNotificationIcon && (
                              <div className="ring-container-db">
                                <div className="circlebtn">
                                  <div className="ringring"></div>
                                </div>
                              </div>
                            )}
                            <span>
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.49922 13.625C6.5649 13.6744 6.63968 13.7103 6.71926 13.7307C6.79885 13.7512 6.88169 13.7557 6.96303 13.7441C7.04437 13.7325 7.12263 13.705 7.19332 13.6631C7.26401 13.6212 7.32575 13.5658 7.375 13.5C7.75341 12.9955 8.24409 12.5859 8.8082 12.3039C9.3723 12.0218 9.99432 11.875 10.625 11.875C11.2557 11.875 11.8777 12.0218 12.4418 12.3039C13.0059 12.5859 13.4966 12.9955 13.875 13.5C13.9242 13.5657 13.9859 13.621 14.0566 13.6628C14.1272 13.7046 14.2054 13.7321 14.2866 13.7437C14.3679 13.7553 14.4506 13.7508 14.5301 13.7304C14.6096 13.7101 14.6843 13.6742 14.75 13.625C14.8157 13.5758 14.871 13.5141 14.9128 13.4434C14.9546 13.3728 14.9821 13.2946 14.9937 13.2134C15.0053 13.1321 15.0008 13.0494 14.9804 12.9699C14.9601 12.8904 14.9242 12.8157 14.875 12.75C14.3216 12.008 13.5836 11.4238 12.7344 11.0555C13.1998 10.6306 13.5258 10.0749 13.6697 9.4614C13.8137 8.84789 13.7688 8.2052 13.5409 7.61767C13.313 7.03014 12.9129 6.52523 12.3929 6.1692C11.873 5.81316 11.2575 5.62265 10.6273 5.62265C9.99718 5.62265 9.38173 5.81316 8.86178 6.1692C8.34182 6.52523 7.94166 7.03014 7.71379 7.61767C7.48593 8.2052 7.44102 8.84789 7.58495 9.4614C7.72888 10.0749 8.05493 10.6306 8.52031 11.0555C7.6694 11.4231 6.92972 12.0074 6.375 12.75C6.27546 12.8825 6.23263 13.0491 6.25592 13.2132C6.27922 13.3773 6.36673 13.5254 6.49922 13.625ZM8.75 8.75C8.75 8.37916 8.85997 8.01665 9.06599 7.70831C9.27202 7.39996 9.56486 7.15964 9.90747 7.01773C10.2501 6.87581 10.6271 6.83868 10.9908 6.91103C11.3545 6.98337 11.6886 7.16195 11.9508 7.42417C12.213 7.6864 12.3916 8.02049 12.464 8.38421C12.5363 8.74792 12.4992 9.12492 12.3573 9.46753C12.2154 9.81014 11.975 10.103 11.6667 10.309C11.3584 10.515 10.9958 10.625 10.625 10.625C10.1277 10.625 9.65081 10.4275 9.29917 10.0758C8.94754 9.72419 8.75 9.24728 8.75 8.75ZM16.25 1.875H5C4.66848 1.875 4.35054 2.0067 4.11612 2.24112C3.8817 2.47554 3.75 2.79348 3.75 3.125V5H2.5C2.33424 5 2.17527 5.06585 2.05806 5.18306C1.94085 5.30027 1.875 5.45924 1.875 5.625C1.875 5.79076 1.94085 5.94973 2.05806 6.06694C2.17527 6.18415 2.33424 6.25 2.5 6.25H3.75V9.375H2.5C2.33424 9.375 2.17527 9.44085 2.05806 9.55806C1.94085 9.67527 1.875 9.83424 1.875 10C1.875 10.1658 1.94085 10.3247 2.05806 10.4419C2.17527 10.5592 2.33424 10.625 2.5 10.625H3.75V13.75H2.5C2.33424 13.75 2.17527 13.8158 2.05806 13.9331C1.94085 14.0503 1.875 14.2092 1.875 14.375C1.875 14.5408 1.94085 14.6997 2.05806 14.8169C2.17527 14.9342 2.33424 15 2.5 15H3.75V16.875C3.75 17.2065 3.8817 17.5245 4.11612 17.7589C4.35054 17.9933 4.66848 18.125 5 18.125H16.25C16.5815 18.125 16.8995 17.9933 17.1339 17.7589C17.3683 17.5245 17.5 17.2065 17.5 16.875V3.125C17.5 2.79348 17.3683 2.47554 17.1339 2.24112C16.8995 2.0067 16.5815 1.875 16.25 1.875ZM16.25 16.875H5V3.125H16.25V16.875Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                            Investor dashboard
                          </Dropdown.Item>
                        )}

                      <Dropdown.Item
                        onClick={() => navigate(pageURLs.inventoryListing)}
                      >
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 2.08984C9.52138 2.08984 9.04293 2.24553 8.64746 2.55697H8.64665L3.69141 6.4624C2.93992 7.05464 2.5 7.95958 2.5 8.91683V16.4535C2.5 17.2513 3.16044 17.9118 3.95833 17.9118H16.0417C16.8396 17.9118 17.5 17.2513 17.5 16.4535V8.91683C17.5 7.95958 17.0601 7.05464 16.3086 6.4624L16.25 6.4152V3.125C16.25 2.95924 16.1841 2.80028 16.0669 2.68308C15.9497 2.56587 15.7908 2.50002 15.625 2.5H13.5417C13.3759 2.50002 13.2169 2.56587 13.0997 2.68308C12.9825 2.80028 12.9167 2.95924 12.9167 3.125V3.78906L11.3525 2.55697C10.9571 2.24553 10.4786 2.08984 10 2.08984ZM10 3.33659C10.2041 3.33659 10.4082 3.40441 10.5794 3.53923L13.1551 5.56803C13.2473 5.64054 13.358 5.68566 13.4746 5.69824C13.5911 5.71082 13.7089 5.69035 13.8144 5.63917C13.9199 5.58798 14.0089 5.50815 14.0712 5.4088C14.1335 5.30945 14.1666 5.19458 14.1667 5.07731V3.75H15V6.71875C15.0001 6.81325 15.0216 6.9065 15.0629 6.9915C15.1042 7.0765 15.1642 7.15102 15.2384 7.20947L15.5355 7.44385C15.9873 7.79994 16.25 8.34158 16.25 8.91683V16.4535C16.25 16.5764 16.1646 16.6618 16.0417 16.6618H3.95833C3.8354 16.6618 3.75 16.5764 3.75 16.4535V8.91683C3.75 8.34158 4.01267 7.79994 4.46452 7.44385L9.42057 3.53923C9.59177 3.40441 9.79592 3.33659 10 3.33659ZM6.04167 9.99512C5.87591 9.99513 5.71695 10.061 5.59974 10.1782C5.48254 10.2954 5.41668 10.4544 5.41667 10.6201V13.9535C5.41668 14.1192 5.48254 14.2782 5.59974 14.3954C5.71695 14.5126 5.87591 14.5784 6.04167 14.5785H8.54167C8.70742 14.5784 8.86638 14.5126 8.98359 14.3954C9.1008 14.2782 9.16665 14.1192 9.16667 13.9535V10.6201C9.16665 10.4544 9.1008 10.2954 8.98359 10.1782C8.86638 10.061 8.70742 9.99513 8.54167 9.99512H6.04167ZM11.4583 9.99512C11.2926 9.99513 11.1336 10.061 11.0164 10.1782C10.8992 10.2954 10.8333 10.4544 10.8333 10.6201V13.9535C10.8333 14.1192 10.8992 14.2782 11.0164 14.3954C11.1336 14.5126 11.2926 14.5784 11.4583 14.5785H13.9583C14.1241 14.5784 14.283 14.5126 14.4003 14.3954C14.5175 14.2782 14.5833 14.1192 14.5833 13.9535V10.6201C14.5833 10.4544 14.5175 10.2954 14.4003 10.1782C14.283 10.061 14.1241 9.99513 13.9583 9.99512H11.4583ZM6.66667 11.2451H7.91667V13.3285H6.66667V11.2451ZM12.0833 11.2451H13.3333V13.3285H12.0833V11.2451Z"
                              fill="#333A48"
                            />
                          </svg>
                        </span>
                        My Inventory
                      </Dropdown.Item>

                      <Dropdown.Item onClick={() => navigate("/my-want-ad")}>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M2.26407 3.05319C2.49849 2.81877 2.81643 2.68707 3.14795 2.68707H16.8979C17.2295 2.68707 17.5474 2.81877 17.7818 3.05319C18.0163 3.28761 18.1479 3.60555 18.1479 3.93707V16.4371C18.1479 16.6537 18.0358 16.8549 17.8515 16.9687C17.6673 17.0826 17.4372 17.093 17.2434 16.9961L15.0229 15.8858L12.8025 16.9961C12.6265 17.0841 12.4194 17.0841 12.2434 16.9961L10.0229 15.8858L7.80246 16.9961C7.6265 17.0841 7.41939 17.0841 7.24344 16.9961L5.02295 15.8858L2.80246 16.9961C2.60871 17.093 2.37863 17.0826 2.19437 16.9687C2.01011 16.8549 1.89795 16.6537 1.89795 16.4371V3.93707C1.89795 3.60555 2.02965 3.28761 2.26407 3.05319ZM16.8979 3.93707L3.14795 3.93707L3.14795 15.4258L4.74344 14.6281C4.9194 14.5401 5.1265 14.5401 5.30246 14.6281L7.52295 15.7383L9.74344 14.6281C9.9194 14.5401 10.1265 14.5401 10.3025 14.6281L12.5229 15.7383L14.7434 14.6281C14.9194 14.5401 15.1265 14.5401 15.3025 14.6281L16.8979 15.4258V3.93707Z"
                              fill="#333A48"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.6479 8.31207C10.6479 7.9669 10.9278 7.68707 11.2729 7.68707H15.0229C15.3681 7.68707 15.6479 7.9669 15.6479 8.31207C15.6479 8.65725 15.3681 8.93707 15.0229 8.93707H11.2729C10.9278 8.93707 10.6479 8.65725 10.6479 8.31207Z"
                              fill="#333A48"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.6479 10.8121C10.6479 10.4669 10.9278 10.1871 11.2729 10.1871H15.0229C15.3681 10.1871 15.6479 10.4669 15.6479 10.8121C15.6479 11.1573 15.3681 11.4371 15.0229 11.4371H11.2729C10.9278 11.4371 10.6479 11.1573 10.6479 10.8121Z"
                              fill="#333A48"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M4.39795 7.06207C4.39795 6.7169 4.67777 6.43707 5.02295 6.43707H8.77295C9.11813 6.43707 9.39795 6.7169 9.39795 7.06207V12.0621C9.39795 12.4073 9.11813 12.6871 8.77295 12.6871H5.02295C4.67777 12.6871 4.39795 12.4073 4.39795 12.0621V7.06207ZM5.64795 7.68707V11.4371H8.14795V7.68707H5.64795Z"
                              fill="#333A48"
                            />
                          </svg>
                        </span>
                        My Want-Listings
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        href={void 0}
                        onClick={() => {
                          window.location.href = "https://www.gitcha.com/help";
                        }}
                      >
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.9375 14.0625C10.9375 14.2479 10.8825 14.4292 10.7795 14.5833C10.6765 14.7375 10.5301 14.8577 10.3588 14.9286C10.1875 14.9996 9.99896 15.0182 9.81711 14.982C9.63525 14.9458 9.4682 14.8565 9.33709 14.7254C9.20598 14.5943 9.11669 14.4273 9.08052 14.2454C9.04434 14.0635 9.06291 13.875 9.13387 13.7037C9.20482 13.5324 9.32499 13.386 9.47916 13.283C9.63333 13.18 9.81458 13.125 10 13.125C10.2486 13.125 10.4871 13.2238 10.6629 13.3996C10.8387 13.5754 10.9375 13.8139 10.9375 14.0625ZM10 5.625C8.27657 5.625 6.875 6.88672 6.875 8.4375V8.75C6.875 8.91576 6.94085 9.07473 7.05806 9.19194C7.17527 9.30915 7.33424 9.375 7.5 9.375C7.66576 9.375 7.82474 9.30915 7.94195 9.19194C8.05916 9.07473 8.125 8.91576 8.125 8.75V8.4375C8.125 7.57812 8.96641 6.875 10 6.875C11.0336 6.875 11.875 7.57812 11.875 8.4375C11.875 9.29688 11.0336 10 10 10C9.83424 10 9.67527 10.0658 9.55806 10.1831C9.44085 10.3003 9.375 10.4592 9.375 10.625V11.25C9.375 11.4158 9.44085 11.5747 9.55806 11.6919C9.67527 11.8092 9.83424 11.875 10 11.875C10.1658 11.875 10.3247 11.8092 10.4419 11.6919C10.5592 11.5747 10.625 11.4158 10.625 11.25V11.1938C12.05 10.932 13.125 9.79531 13.125 8.4375C13.125 6.88672 11.7234 5.625 10 5.625ZM18.125 10C18.125 11.607 17.6485 13.1779 16.7557 14.514C15.8629 15.8502 14.594 16.8916 13.1093 17.5065C11.6247 18.1215 9.99099 18.2824 8.4149 17.9689C6.8388 17.6554 5.39106 16.8815 4.25476 15.7452C3.11846 14.6089 2.34463 13.1612 2.03112 11.5851C1.71762 10.009 1.87852 8.37535 2.49348 6.8907C3.10844 5.40605 4.14985 4.1371 5.486 3.24431C6.82214 2.35152 8.39303 1.875 10 1.875C12.1542 1.87727 14.2195 2.73403 15.7427 4.25727C17.266 5.78051 18.1227 7.84581 18.125 10ZM16.875 10C16.875 8.64025 16.4718 7.31104 15.7164 6.18045C14.9609 5.04987 13.8872 4.16868 12.631 3.64833C11.3747 3.12798 9.99238 2.99183 8.65876 3.2571C7.32514 3.52237 6.10013 4.17716 5.13864 5.13864C4.17716 6.10013 3.52238 7.32513 3.2571 8.65875C2.99183 9.99237 3.12798 11.3747 3.64833 12.6309C4.16868 13.8872 5.04987 14.9609 6.18046 15.7164C7.31105 16.4718 8.64026 16.875 10 16.875C11.8227 16.8729 13.5702 16.1479 14.8591 14.8591C16.1479 13.5702 16.8729 11.8227 16.875 10Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                        Help
                      </Dropdown.Item>

                      <Dropdown.Divider />
                      <Dropdown.Item onClick={() => handleLogOut()}>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.75 16.875C8.75 17.0408 8.68415 17.1997 8.56694 17.3169C8.44973 17.4342 8.29076 17.5 8.125 17.5H3.75C3.41848 17.5 3.10054 17.3683 2.86612 17.1339C2.6317 16.8995 2.5 16.5815 2.5 16.25V3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H8.125C8.29076 2.5 8.44973 2.56585 8.56694 2.68306C8.68415 2.80027 8.75 2.95924 8.75 3.125C8.75 3.29076 8.68415 3.44973 8.56694 3.56694C8.44973 3.68415 8.29076 3.75 8.125 3.75H3.75V16.25H8.125C8.29076 16.25 8.44973 16.3158 8.56694 16.4331C8.68415 16.5503 8.75 16.7092 8.75 16.875ZM17.3172 9.55781L14.1922 6.43281C14.0749 6.31554 13.9159 6.24965 13.75 6.24965C13.5841 6.24965 13.4251 6.31554 13.3078 6.43281C13.1905 6.55009 13.1247 6.70915 13.1247 6.875C13.1247 7.04085 13.1905 7.19991 13.3078 7.31719L15.3664 9.375H8.125C7.95924 9.375 7.80027 9.44085 7.68306 9.55806C7.56585 9.67527 7.5 9.83424 7.5 10C7.5 10.1658 7.56585 10.3247 7.68306 10.4419C7.80027 10.5592 7.95924 10.625 8.125 10.625H15.3664L13.3078 12.6828C13.1905 12.8001 13.1247 12.9591 13.1247 13.125C13.1247 13.2909 13.1905 13.4499 13.3078 13.5672C13.4251 13.6845 13.5841 13.7503 13.75 13.7503C13.9159 13.7503 14.0749 13.6845 14.1922 13.5672L17.3172 10.4422C17.3753 10.3841 17.4214 10.3152 17.4529 10.2393C17.4843 10.1635 17.5005 10.0821 17.5005 10C17.5005 9.91787 17.4843 9.83654 17.4529 9.76066C17.4214 9.68479 17.3753 9.61586 17.3172 9.55781Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                        Log Out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ) : (
                <div>
                  <Button
                    variant="secondary"
                    className="btn-ml-6 mr-0 btn-tweak"
                    onClick={(e) =>
                      handleAgentOnboardingModal({
                        showPopup: true,
                        userAction: LOGIN,
                      })
                    }
                  >
                    Sign In
                  </Button>{" "}
                  <Button
                    variant="primary"
                    className="btn-ml-6 mr-0 btn-tweak"
                    onClick={(e) =>
                      handleAgentOnboardingModal({
                        showPopup: true,
                        userAction: SIGNUP,
                      })
                    }
                  >
                    Sign Up
                  </Button>
                </div>
              )}
            </div>
          </li>
        </ul>
      </div>
      {memberProfileModal && (
        <MemberUserProfileModal
          show={memberProfileModal}
          onHide={handleMemberProfileModal}
          continueClick={handlMemberProfileContinue}
        ></MemberUserProfileModal>
      )}

      {agentTitleModalShow && (
        <AgentTitleModal
          show={agentTitleModalShow}
          handleAgentContinueClick={handleAgentTitleContinueClick}
          handleTitleClick={handleTitleClick}
          titleContinueState={titleContinueState}
          selectedTitle={selectedTitle}
          handleUserTypeModal={handleUserTypeModal}
          setAgentTitleModal={setAgentTitleModal}
        ></AgentTitleModal>
      )}

      {userTypeModalShow && (
        <CheckAgentModal
          show={userTypeModalShow}
          handleUserTypeContinueClick={handleUserTypeContinueClick}
          handleUserTypeSelection={handleUserTypeSelection}
          isDisabled={
            _.get(userData, "userInfo.userType", null)
              ? false
              : isDisabledUserContinue
          }
          selectedType={userType || _.get(userData, "userInfo.userType", null)}
        ></CheckAgentModal>
      )}

      {agentProfileModal && (
        <AgentInfoModal
          show={agentProfileModal}
          saveAgentDetails={saveAgentDetails}
          UserId={UserId}
          onClickChangePhoto={(image, isLogo) => {
            ShowPofileImageUploadModalShow(isLogo);
            setImage(image);
          }}
          reRenderEditProfileModel={reRenderEditProfileModel}
          uploadedImageUrl={uploadedImageUrl}
          uploadedLogoUrl={uploadedLogoUrl}
        ></AgentInfoModal>
      )}

      <ProfileImageCropper
        userId={UserId}
        image={image}
        show={showPofileImageUploadModal}
        onHide={() => {
          ShowPofileImageUploadModalClose();
        }}
        isSquare={isSquareImage}
        updateImageAfterCrop={(imageUrl) => {
          renderEditProfileModel(imageUrl);
          ShowPofileImageUploadModalClose();
        }}
      />
      {agentPreferenceModal && (
        <AgentLiketoStartModal
          show={agentPreferenceModal}
          onHide={() => handleAgentPrefernceModal(false)}
          handleAgentPreferenceContinue={handleAgentPreferenceContinue}
          backClick={handleAgentPrefernceBack}
          preferenceSelection={handlePreferenceSelection}
          agentPreference={agentPreference}
        ></AgentLiketoStartModal>
      )}

      <EmailVerifiedModal
        show={showEmailVerifiedModal}
        onHide={handleEmailVerifiedModalClose}
      />
      <EmailChangeConfirmedModal
        show={showEmailConfirmedModal}
        onHide={handleEmailConfirmedModalClose}
        emailNotVerified={emailNotVerified}
      />
      <EmailChangeRevokedModal
        show={showEmailChangeRevokedModal}
        onHide={handleEmailChangeRevokedModalClose}
      />
      <CheckEmailDeletionModal
        process="deletion"
        show={checkEmailPopup}
        hide={handleCheckEmailDeletionModalClose}
      />
      <PremiumPlanModal
        userDetails={userDetails}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        updateReloadParam={updateReloadParam}
        handleShowAgentModal={handleShowAgentModal}
        handleAgentTitleModal={handleAgentTitleModal}
        showPlanModal={PremiumPlanModalShow}
      />
      <BasicPlanModal
        userDetails={userDetails}
        show={showBasicPlanModal}
        onHide={BasicPlanModalClose}
        updateReloadParam={updateReloadParam}
        handleMemberProfileModal={handleMemberProfileModal}
        handleUserTypeModal={handleUserTypeModal}
        showPlanModal={BasicPlanModalShow}
      />
      <AgentOnboardingModal
        agentOnboardingPopup={agentOnboardingPopup}
        saveAgentDetails={saveAgentDetails}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
        handleUserTypeModal={handleUserTypeModal}
        handleResetPwdModal={handleResetPwdModal}
        handleUserLogin={handleUserLogin}
      />

      <ResetPassword
        resetPwdModal={resetPwdModal}
        handleResetPwdModal={handleResetPwdModal}
        resetPwdModalType={resetPwdModalType}
        resetPassWord={resetPassWord}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
      />
      <CheckResetEmailModal
        show={resetEmailModalState}
        onHide={handleResetEmailModal}
        email={email}
        process="ResetPwd"
      />

      <ContactModal
        show={contactModalState}
        onHide={ContactModalClose}
        sourceType={1} // help menu
      />
    </div>
  );
};
export default CommonHeader;
